/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "enabledByDefault": true,
  "name": "Skewing in costume editor",
  "description": "Hold Ctrl while scaling an object on its sides to skew it. Hold Alt while skewing an object to skew it from its center.",
  "info": [
    {
      "text": "On macOS, use the Command key instead of the Control key and the Option key instead of the Alt key.",
      "id": "useCmdOnMac"
    }
  ],
  "credits": [
    {
      "name": "CST1229",
      "link": "https://scratch.mit.edu/users/CST1229/"
    }
  ],
  "tags": [],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "dynamicDisable": true
};
export default manifest;
